import { request, qs } from './api';

// Hotel moderation — fill in / correct coordinates + address, or delete.
// All endpoints require the admin JWT (handled by request()).

// GET /admin/hotels?page&limit&search -> { data:[{id,type,name,address,city,lat,lon}], total, page, limit }
export const listHotels = (params) => request(`/hotels${qs(params)}`);

// PUT /admin/hotels/:id { lat?, lon?, address? } -> { data: Row }. Sending none -> 400.
export const updateHotel = (id, body) => request(`/hotels/${id}`, { method: 'PUT', body });

// DELETE /admin/hotels/:id -> { data: { id, type, deleted:true } }
export const deleteHotel = (id) => request(`/hotels/${id}`, { method: 'DELETE' });

// POST /admin/hotels/bulk — [{ id, lat?, lon?, address?, delete? }, ...]
// delete:true removes the row; otherwise the supplied fields are updated.
// -> { data: { results, updated, deleted, failed, total } }
export const bulkHotels = (items) => request('/hotels/bulk', { method: 'POST', body: items });
